import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import './style.scss';
import Content from "../../../layout/content/Content";
import classNames from "classnames";
import Head from "../../../layout/head/Head";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Tooltip } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PaginationComponent,
  Row,
  Col,

  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent

} from "../../../components/Component";

import DatePicker from "react-datepicker";
import { QueryClient, QueryClientProvider, useQuery, useMutation } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";

import TableHead from "../common/TableHead";

const InvoiceListing = () => {

  const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));

  const { errors, register, handleSubmit, control, reset } = useForm();

  const [data, setData] = useState([]);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [sort, setSortState] = useState("DESC");

  const [totalCount, setTotalCount] = useState('');

  const [searchData, setSearchData] = useState({ product_id: '', po_number: '', designer_code: '' });


  const formClass = classNames({
    "form-validate": true,
    "is-alter": true,
  });

  const sortFunc = (val) => {

    console.log(val);
  };

  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);


  console.log('indexOfFirstItem', indexOfFirstItem);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);



  useEffect(async () => {

    console.log(itemPerPage);

    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;

    var payload = {
      sort: sort,
      offsetItem: indexOfFirstItem,

      product_id: searchData?.product_id,
      po_number: searchData?.po_number,
      designer_code: searchData?.designer_code,
      itemPerPage

    }

    refetchPOList.mutate(payload)
  }, [itemPerPage, currentPage, sort, searchData]);



  const getPurchseOrders = async (param) => {
    try {
      const { data } = await loginAxios.get(`designers/purchase-order?sortBy=${param.sort}&offset=${param.offsetItem}&limit=${param.itemPerPage}&product_id=${param.product_id}&po_number=${param.po_number}&designer_code=${param.designer_code}`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const refetchPOList = useMutation(['getPurchseOrders'], getPurchseOrders, {
    // refetchOnMount: false,
    // refetchOnWindowFocus: false,
    onSettled(data, error) {
      if (data) {

        console.log(data.data);
        setData(data.data.result);

        setTotalCount(data.data.total_count)
      }
    }
  })


  const handleViewInvoice = (item) => {
    console.log(item);    
    window.open(`${item.po_url}`, "_blank")
    // window.open(`https://bridge.azaonline.in/mod/purchase-order/x-purchase-order-pdf.php?poNumber=${item.poNumber}&orderID=${item.orderNumber}&designerID=${item.designerID}&orderDetailID=${item.orderDetailID}`, "_blank")
  }


  const [modalLg, setModalLg] = useState(false);
  const toggleLg = () => setModalLg(!modalLg);

  const [trackingData, setTrackingData] = useState({});

  const [poNumber, setPoNumber] = useState('');

  const [dispatchModal, setdispatchModal] = useState(false);
  const toggleDispatchModal = () => {
    setdispatchModal(!dispatchModal);
    setPoNumber('');
    setDispatchDate('');
    reset();
  };


  const getTrackingDetails = async (param) => {
    try {
      const { data } = await loginAxios.get(`designers/view-trcking-details?order_detail_id=${param}`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  const getTrackingDetailsCall = useMutation(getTrackingDetails, {
    onSettled(data, error) {
      if (data) {
        console.log(data);
        setTrackingData(data?.data?.result);
      } else if (error) {
        console.log(error);
      }
    }
  })



  /////////////////////////////////////////////DISPATCH PO ///////////////////////////////////////////////////////////////////////


  const dispatchPO = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/dispatch-po`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  const dispatchPOCall = useMutation(dispatchPO, {
    onSettled(data, error) {
      toggleDispatchModal();
      if (data) {
        console.log(data);


        toast.success(data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });

      } else if (error) {
        console.log(error);

        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
    }
  })

  /////////////////////////////////////////////DISPATCH PO ///////////////////////////////////////////////////////////////////////


  const handleViewDetails = (item) => {
    console.log(item);
    getTrackingDetailsCall.mutate(item?.orderDetailID);
    toggleLg();
  }


  const handleDispatchPO = (item) => {
    toggleDispatchModal();
    setPoNumber(item.poNumber);
  }


  const onFormSubmit = (e) => {
    console.log(e);
    var payload = e;
    payload.po_number = parseInt(e.po_number);
    console.log(payload)
    dispatchPOCall.mutate(payload);
  }

  const [dispatchDate, setDispatchDate] = useState('');


  const [infoText, setInfoText] = useState('');

  const [userGuideModal, setuserGuideModal] = useState(false);

  const toggleuserGuideModal = (val) => {
    setuserGuideModal(!userGuideModal);

    if (val != undefined) {
      setInfoText(val);
    }
  };





  const searchHandler = async (data) => {

    // console.log(data);

    setCurrentPage(1);
    setSearchData(data);

    // const indexOfLastItem = currentPage * itemPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemPerPage;

    // var payload = {
    //   sort: sort,
    //   offsetItem: 0,

    //   product_id: data?.product_id,
    //   po_number: data?.po_number,
    //   designer_code: data?.designer_code,

    // }

    // refetchPOList.mutate(payload)

  };



  let seachFeild = {
    po_number: '',
    designer_code: '',
    product_id: '',
  };



  const seachFeildType = {

    po_number: {
      tag: "input",
      type: "text",
    },

    designer_code: {
      tag: "input",
      type: "text",
    },
    product_id: {
      tag: "input",
      type: "text",
    }

  };


  const handleGetData = () => {
    setSearchData({ product_id: '', po_number: '', designer_code: '' });
  }



  // toggle = targetName => {
  //   if (!this.state[targetName]) {
  //     this.setState({
  //       ...this.state,
  //       [targetName]: {
  //         tooltipOpen: true
  //       }
  //     });
  //   } else {
  //     this.setState({
  //       ...this.state,
  //       [targetName]: {
  //         tooltipOpen: !this.state[targetName].tooltipOpen
  //       }
  //     });
  //   }
  // };


  // const isToolTipOpen = targetName => {
  //   return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  // };

  return (
    <React.Fragment>
      <Head title="Invoice List"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Purchase Orders <Icon style={{ fontSize: '18px' }} name="help" onClick={() => toggleuserGuideModal('purchaseOrder')}></Icon></BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card className="card-stretch">

            <Row className="gy-3">
              <Col lg={10}>
                <TableHead
                  searchHandler={searchHandler}
                  searchFieldData={seachFeild}
                  seachFeildType={seachFeildType}
                  reloadHandler={() => {
                    handleGetData();
                  }}
                  setSearchText={setSearchText}
                  setSelectedItems={setSelectedItems}
                  pageName="purchase-order-listing"
                />
              </Col>
              <Col lg={2} >

                <div style={{ display: 'flex', height: '100%' }}>

                  <div className="card-tools mr-n1" style={{ alignItems: 'center' }}>
                    <ul className="btn-toolbar">
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            href="#toggle"
                            onClick={(ev) => ev.preventDefault()}
                            className="link link-light link-sm dropdown-indicator"
                          >
                            {sort == "ASC" ? 'Oldest first' : 'Newest First'}
                          </DropdownToggle>

                          <DropdownMenu right className="dropdown-menu-xs">

                            <ul className="link-check">
                              <li>
                                <span>Order</span>
                              </li>
                              <li className={sort === "DESC" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("DESC");
                                    sortFunc("DESC");
                                  }}
                                >
                                  Newest First
                                </DropdownItem>
                              </li>
                              <li className={sort === "ASC" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("ASC");
                                    sortFunc("ASC");
                                  }}
                                >
                                  Oldest first
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </div>

                </div>
              </Col>
            </Row>

            <div className="card-inner-group">
              {/* <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">

                  </div>
                  <div className="card-tools mr-n1">
                    <ul className="btn-toolbar">
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            href="#toggle"
                            onClick={(ev) => ev.preventDefault()}
                            className="link link-light link-sm dropdown-indicator"
                          >
                            {sort == "ASC" ? 'Oldest first' : 'Newest First'}
                          </DropdownToggle>

                          <DropdownMenu right className="dropdown-menu-xs">

                            <ul className="link-check">
                              <li>
                                <span>Order</span>
                              </li>
                              <li className={sort === "DESC" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("DESC");
                                    sortFunc("DESC");
                                  }}
                                >
                                  Newest First
                                </DropdownItem>
                              </li>
                              <li className={sort === "ASC" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("ASC");
                                    sortFunc("ASC");
                                  }}
                                >
                                  Oldest first
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </div>
                  <div className={`card-search search-wrap ${!onSearch ? "active" : ""}`}>
                    <div className="search-content">
                      <Button
                        className="search-back btn-icon toggle-search"
                        onClick={() => {
                          setSearchText("");
                          toggle();
                        }}
                      >
                        <Icon name="arrow-left"></Icon>
                      </Button>
                      <input
                        type="text"
                        className="form-control border-transparent form-focus-none"
                        placeholder="Search by Order Id"
                        value={onSearchText}
                        onChange={(e) => onFilterChange(e)}
                      />
                      <Button className="search-submit btn-icon">
                        <Icon name="search"></Icon>
                      </Button>
                    </div>
                  </div>
                </div>
              </div> */}


              <DataTable className="card-stretch">
                <DataTableBody compact>
                  <DataTableHead>
                    {/* <DataTableRow>
                      <span className="sub-text">User</span>
                    </DataTableRow> */}
                    <DataTableRow size="md">
                      <span className="lead-text">PO NUMBER</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span className="lead-text">DESIGNER CODE</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="lead-text">PRODUCT ID</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="lead-text">PRODUCT TITLE</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                      <span className="lead-text">SIZE</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                      <span className="lead-text">DELIVERY DATE</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                      <span className="lead-text">STATUS <Icon name="help" onClick={() => toggleuserGuideModal('status')}></Icon></span>
                    </DataTableRow>

                    <DataTableRow>
                      <span className="lead-text">TRACKING STATUS <Icon name="help" onClick={() => toggleuserGuideModal('trackingStatus')}></Icon></span>
                    </DataTableRow>

                    <DataTableRow>
                      <span className="lead-text">ACTION</span>
                    </DataTableRow>

                  </DataTableHead>

                  {data?.length > 0
                    ? data?.map((item) => {
                      return (
                        <DataTableItem key={item.id}>

                          <DataTableRow size="md">
                            <span>{item.poNumber}</span>
                          </DataTableRow>

                          <DataTableRow size="sm">
                            <span>{item.designerCode}</span>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span>{item.productID}</span>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span>{item.productTitle}</span>
                          </DataTableRow>

                          <DataTableRow size="md">
                            <span>{item.sizeTitle}</span>
                          </DataTableRow>


                          <DataTableRow size="md">
                            <span>{item.deliveryDate}</span>
                          </DataTableRow>

                          <DataTableRow size="lg">
                            <span className="tb-odr-date">

                              {(item.status === "Pending" || item.status === "Returned by Aza to fix") ? <>

                                {item.delay_days < -6 ? <Badge className="badge-green" color='success'>On time</Badge> : (item.delay_days <= -4 ? <Badge className="badge-orange"
                                  color='warning'>Might get delayed</Badge> : (item.delay_days > -4 && item.delay_days <= 0 ? <Badge className="badge-red"
                                    color='danger'>Delayed</Badge> : <Badge className="badge-red" color='danger'>Risk of cancellation</Badge>))}

                              </>
                                : '-'}

                            </span>
                          </DataTableRow>

                          <DataTableRow size="md">
                            <span className="tb-odr-status">

                              {item.status != null &&
                                <Badge
                                  color={
                                    (item.status === "Pending" || item.status === "Failed quality check" || item.status === "Returned by Aza to fix" || item.status === "Rejected" || item.status.toLowerCase() === "cancelled") ? "danger" : "success"}
                                  className="badge-dot"
                                >
                                  {item.status} {item.reason != '' && <>
                                    <div className="card-tools">
                                      <Icon name="help" id={`btn-${item.poNumber}`} />                     
                                      <UncontrolledTooltip
                                        placement="right"                                        
                                        target={`btn-${item.poNumber}`}                                        
                                      >
                                        {item.reason}
                                      </UncontrolledTooltip>
                                    </div>                                    
                                  </>
                                  }
                                </Badge>
                              }

                            </span>
                          </DataTableRow>

                          <DataTableRow size="md" className="action-col-width">
                            <div className="tb-odr-btns d-none d-sm-inline">

                              <Button id="dropdownToggleLabel" className="btn-round btn-icon" color="light" size="sm" onClick={() => handleViewInvoice(item)}>
                                <Icon name="download" />
                              </Button>

                              <UncontrolledTooltip autohide={false} placement="top" target="dropdownToggleLabel">
                                Download PO
                              </UncontrolledTooltip>
                            </div>

                            {userLoginDetails.profile_approval_status != "PENDING" ? <>

                              {(item.status === "Rejected" || item.status === "Returned by Aza to fix" || item.status === "Pending") ? <>

                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <ul className="link-list-plain">

                                      {(item.status === "Rejected" || item.status === "Returned by Aza to fix") &&
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#view"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleViewDetails(item);
                                            }}
                                          >
                                            View Tracking Details
                                          </DropdownItem>
                                        </li>
                                      }

                                      {(item.status === "Pending" || item.status === "Returned by Aza to fix") &&
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#print"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleDispatchPO(item)
                                            }}
                                          >
                                            Dispatch PO
                                          </DropdownItem>
                                        </li>
                                      }
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </> : null}
                            </> : null}
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                    : null}

                </DataTableBody>

                <div className="card-inner">
                  {data.length > 0 ? (
                    // <PaginationComponent
                    //   itemPerPage={itemPerPage}
                    //   totalItems={totalCount}
                    //   paginate={paginate}
                    //   currentPage={currentPage}
                    // />

                    <PaginationComponent
                      itemPerPage={itemPerPage}                      
                      totalItems={totalCount || []}
                      paginate={paginate}
                      currentPage={currentPage}                      
                      setItemPerPage={setItemPerPage}
                      setCurrentPage={setCurrentPage}                                            
                    />
                  ) : (
                    <div className="text-center">
                      <span className="text-silent">No data found</span>
                    </div>
                  )}
                </div>
              </DataTable>
            </div>

          </Card>
        </Block>
      </Content>


      <Modal size="lg" isOpen={modalLg} toggle={toggleLg}>
        <ModalHeader
          toggle={toggleLg}
          close={
            <button className="close" onClick={toggleLg}>
              <Icon name="cross" />
            </button>
          }
        >
          View Tracking Details
        </ModalHeader>
        <ModalBody>
          <div className="nk-tnx-details mt-sm-3">
            <Row className="gy-3">
              <Col lg={6}>
                <span className="sub-text">Courier Name</span>
                <span className="caption-text">{trackingData?.ShippingCompanyName}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Tracking Number</span>
                <span className="caption-text">{trackingData?.trackingIDRtv}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Date of Dispatch</span>
                <span className="caption-text">{moment(trackingData?.trackDateRtv).format('DD-MM-YYYY')}</span>
              </Col>
            </Row>
          </div>

        </ModalBody>
      </Modal>





      <Modal size="lg" isOpen={dispatchModal} toggle={toggleDispatchModal}>
        <ModalHeader
          toggle={toggleDispatchModal}
          close={
            <button className="close" onClick={toggleDispatchModal}>
              <Icon name="cross" />
            </button>
          }
        >
          Dispatch PO
        </ModalHeader>
        <ModalBody>

          {/* <div className="nk-modal-head">
            <h4 className="nk-modal-title title">
              Product 
                <small className="text-primary">#676568</small>
            </h4>            
          </div> */}
          <div className="nk-tnx-details mt-sm-3">



            <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
              <Row className="g-gs">

                <Col md="6">
                  <FormGroup>
                    <Label className="form-label" htmlFor="po_number">
                      PO Number*
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="po_number"
                        className="form-control"
                        name="po_number"
                        ref={register()}
                        defaultValue={poNumber}
                        readOnly
                      />
                      {errors.po_number && <span className="invalid">This field is required</span>}
                    </div>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label className="form-label" htmlFor="courier_name">
                      Courier Name*
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="courier_name"
                        className="form-control"
                        name="courier_name"
                        ref={register({ required: true })}
                      />
                      {errors.courier_name && <span className="invalid">This field is required</span>}
                    </div>
                  </FormGroup>
                </Col>


                <Col md="6">
                  <FormGroup>
                    <Label className="form-label" htmlFor="tracking_number">
                      Tracking Number*
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="tracking_number"
                        className="form-control"
                        name="tracking_number"
                        ref={register({ required: true })}
                      />
                      {errors.tracking_number && <span className="invalid">This field is required</span>}
                    </div>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup style={{ zIndex: '99' }}>
                    <label className="form-label">Dispatch Date*</label>
                    <Controller
                      control={control}
                      name="dispatch_date"
                      render={(props) => (
                        <DatePicker
                          className="input"
                          placeholderText="Select date"
                          onChange={(e) => {
                            props.onChange(e);
                            setDispatchDate(moment(e).format('YYYY-MM-DD'))
                          }}
                          selected={props.value}
                          dateFormat="yyyy-MM-dd"
                          maxDate={new Date()}
                          customInput={
                            <div className="form-control-wrap">
                              <input
                                ref={register({ required: true })}
                                type="text"
                                id="dispatch_date"
                                name="dispatch_date"
                                className="form-control"
                                // defaultValue={financialDetails?.dispatch_date}
                                value={dispatchDate}
                                autoComplete="off"
                              />
                              {errors.dispatch_date && <span className="invalid">This field is required</span>}
                            </div>
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row className="g-gs">
                <Col md="12">
                  <FormGroup>
                    <Button type="submit" color="primary" size="lg">
                      Submit
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </div>

        </ModalBody>
      </Modal>









      <Modal size="md" isOpen={userGuideModal} toggle={toggleuserGuideModal}>
        <ModalHeader
          toggle={toggleuserGuideModal}
          close={
            <button className="close" onClick={toggleuserGuideModal}>
              <Icon name="cross" />
            </button>
          }
        >

          {infoText == 'status' && 'Terms used – “Status” column:'}

          {infoText == 'trackingStatus' && 'Terms used – “Tracking status” column:'}

          {infoText == 'purchaseOrder' && 'User guide for using purchase orders dashboard:'}


        </ModalHeader>
        <ModalBody>

          <div className="nk-tnx-details mt-sm-3">

            {infoText == 'status' && <>

              {/* <p className="lead">Terms used – “Status” column:</p> */}
              <table className="table table-bordered mt-3 table-sm">
                <tbody>
                  <tr>
                    <th scope="row" width={'30%'} >Risk of cancellation</th>
                    <td>If PO is not dispatched by designer after the PO delivery date, there is a risk of cancellation by customer which is reflected in this status. </td>
                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >Delayed</th>
                    <td>If PO is not dispatched by designer 3 days before the PO delivery date status is shown as “Delayed”.</td>
                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >Might get delayed</th>
                    <td>If PO is not dispatched by designer 6 days before the PO delivery date, then status is shown as “Might get delayed”.</td>

                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >On time</th>
                    <td>For all other cases, status is shown as “On time”</td>
                  </tr>
                </tbody>
              </table>
            </>}



            {infoText == 'trackingStatus' && <>
              {/* <p className="lead">Terms used – “Tracking status” column:</p> */}
              <table className="table table-bordered mt-3 table-sm">
                <tbody>
                  <tr>
                    <th scope="row" width={'30%'} >Pending</th>
                    <td>PO is not dispatched by designer </td>
                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >Dispatched</th>
                    <td>PO is dispatched by designer </td>
                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >Delivered to Aza</th>
                    <td>Product is received by Aza </td>

                  </tr>
                  <tr>
                    <th scope="row" width={'30%'} >Completed</th>
                    <td>Product is marked as “Quality check – Passed” by Aza </td>
                  </tr>



                  <tr>
                    <th scope="row" width={'30%'} >Failed quality check</th>
                    <td>Product is marked as “Quality check – Failed” by Aza </td>
                  </tr>



                  <tr>
                    <th scope="row" width={'30%'} >Returned by Aza to fix</th>
                    <td>Aza sends back the product for correction after quality checks fail</td>
                  </tr>



                  <tr>
                    <th scope="row" width={'30%'} >Rejected</th>
                    <td>Aza sends back the product permanently after quality checks fail </td>
                  </tr>


                  <tr>
                    <th scope="row" width={'30%'} >Cancelled</th>
                    <td>PO is cancelled by Aza </td>
                  </tr>

                </tbody>
              </table>

            </>}

            {infoText == 'purchaseOrder' &&

              <div>
                {/* <p className="lead">User guide for using purchase orders dashboard:</p> */}

                <li>
                  Click on “Download PO” to download a copy of Purchase order.
                </li>

                <li>Dispatch PO: When the tracking status of a PO is either “Pending” or “Returned by Aza to fix”, user will be able to dispatch PO. Click on the three dots under action column and select “Dispatch PO”. A pop up will open where user needs to enter dispatch details – Courier Name, Tracking Number and Dispatch Date. Once dispatch is done, it will be reflected in “tracking status” column.
                </li>

                <li>View tracking details: When the tracking status of PO is either “Returned by Aza to fix” or “Rejected”, user can view the tracking details of shipment sent by Aza. Click on the three dots under action column and select “View Tracking Details”. Users can view below details – Courier name, tracking number and date of dispatch.
                </li>

              </div>
            }
          </div>

        </ModalBody>
      </Modal>
      <ToastContainer />
    </React.Fragment>
  );
};
export default InvoiceListing;
